/**
 * COURE.HUB.DS.USSD.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DeleteResult } from '../model/deleteResult';
import { USSDCampaignModel } from '../model/uSSDCampaignModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CampaignService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCampaignDeleteDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteResult>;
    public apiCampaignDeleteDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteResult>>;
    public apiCampaignDeleteDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteResult>>;
    public apiCampaignDeleteDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteResult>('delete',`${this.basePath}/api/Campaign/delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param serviceProviderId 
     * @param serviceId 
     * @param campaignName 
     * @param shortCode 
     * @param shortCodeKeyNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCampaignDetailGet(id?: string, serviceProviderId?: string, serviceId?: string, campaignName?: string, shortCode?: string, shortCodeKeyNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<USSDCampaignModel>;
    public apiCampaignDetailGet(id?: string, serviceProviderId?: string, serviceId?: string, campaignName?: string, shortCode?: string, shortCodeKeyNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<USSDCampaignModel>>;
    public apiCampaignDetailGet(id?: string, serviceProviderId?: string, serviceId?: string, campaignName?: string, shortCode?: string, shortCodeKeyNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<USSDCampaignModel>>;
    public apiCampaignDetailGet(id?: string, serviceProviderId?: string, serviceId?: string, campaignName?: string, shortCode?: string, shortCodeKeyNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('Id', <any>id);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('ServiceProviderId', <any>serviceProviderId);
        }
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('ServiceId', <any>serviceId);
        }
        if (campaignName !== undefined && campaignName !== null) {
            queryParameters = queryParameters.set('CampaignName', <any>campaignName);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('ShortCode', <any>shortCode);
        }
        if (shortCodeKeyNumber !== undefined && shortCodeKeyNumber !== null) {
            queryParameters = queryParameters.set('ShortCodeKeyNumber', <any>shortCodeKeyNumber);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<USSDCampaignModel>('get',`${this.basePath}/api/Campaign/detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param serviceId 
     * @param campaignName 
     * @param shortCode 
     * @param shortCodeKeyNumber 
     * @param startFrom 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCampaignDetailsGet(serviceProviderId?: string, serviceId?: string, campaignName?: string, shortCode?: string, shortCodeKeyNumber?: string, startFrom?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<USSDCampaignModel>>;
    public apiCampaignDetailsGet(serviceProviderId?: string, serviceId?: string, campaignName?: string, shortCode?: string, shortCodeKeyNumber?: string, startFrom?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<USSDCampaignModel>>>;
    public apiCampaignDetailsGet(serviceProviderId?: string, serviceId?: string, campaignName?: string, shortCode?: string, shortCodeKeyNumber?: string, startFrom?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<USSDCampaignModel>>>;
    public apiCampaignDetailsGet(serviceProviderId?: string, serviceId?: string, campaignName?: string, shortCode?: string, shortCodeKeyNumber?: string, startFrom?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('ServiceProviderId', <any>serviceProviderId);
        }
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('ServiceId', <any>serviceId);
        }
        if (campaignName !== undefined && campaignName !== null) {
            queryParameters = queryParameters.set('CampaignName', <any>campaignName);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('ShortCode', <any>shortCode);
        }
        if (shortCodeKeyNumber !== undefined && shortCodeKeyNumber !== null) {
            queryParameters = queryParameters.set('ShortCodeKeyNumber', <any>shortCodeKeyNumber);
        }
        if (startFrom !== undefined && startFrom !== null) {
            queryParameters = queryParameters.set('startFrom', <any>startFrom);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<USSDCampaignModel>>('get',`${this.basePath}/api/Campaign/details`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCampaignInsertPost(body?: USSDCampaignModel, observe?: 'body', reportProgress?: boolean): Observable<USSDCampaignModel>;
    public apiCampaignInsertPost(body?: USSDCampaignModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<USSDCampaignModel>>;
    public apiCampaignInsertPost(body?: USSDCampaignModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<USSDCampaignModel>>;
    public apiCampaignInsertPost(body?: USSDCampaignModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<USSDCampaignModel>('post',`${this.basePath}/api/Campaign/insert`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCampaignUpdatePut(body?: USSDCampaignModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiCampaignUpdatePut(body?: USSDCampaignModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiCampaignUpdatePut(body?: USSDCampaignModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiCampaignUpdatePut(body?: USSDCampaignModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/Campaign/update`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
